import gql from 'graphql-tag';

export const createOrderMutation = gql`
  mutation createOrder($input: CreateOrderInput!) {
    createOrder(input: $input) {
      Status
    }
  }
`;
